export const data = [
  {
    id: 1,
    title: "Lepiota",
    date: "(Kasım 14-30)",
    desc: "Dede mantarı olarak bilenen mantar çeşidi, kahvarengi lekeli şapkaya sahiptir.Yenilebilir mantar türleri ile karıştırılabilen mantar; havuz kenarlarında, yol kenarlarında, parklarda, yaprak altlarında yetişir.",
    image:
      "https://cdn.pixabay.com/photo/2016/10/24/14/24/mushroom-1766196_640.jpg",
  },
  {
    id: 2,
    title: "İstiridye",
    date: "(Nisan 1-30)",
    desc: "Doğu Asya’ya özgü bir mantar çeşidi olan Shiitake mantarı, kültür mantarı olarak yetiştirilir.Eski dönemlerde ev yapımı ilaçların ana maddesi olan mantar çeşidi; ağır kokusu nedeniyle tek başına değil, diğer mantarlarla karıştırılarak tüketilir.",
    image:
      "https://cdn.pixabay.com/photo/2023/01/25/09/18/oyster-mushrooms-7742902_640.jpg",
  },
  {
    id: 3,
    title: "Amanita Muscaria",
    date: "(Kasım 1-30)",
    desc: "Gelin mantarı ve sinek mantarı olarak da adlandırılan mantar çeşidi, delilik yaratan krizleri nedeniyle Panherina sendromuna neden olur, bu mantarı yiyen kişilerde ölüm nadir olarak görülür.İbotenik asit ve müsimol bileşenleri nedeniyle zehirleyen mantar; nedensiz gülmelere, hayal görmeye, kas spazmlarına, konuşma, görme ve işitme bozukluklarına neden olur.",
    image:
      "https://cdn.pixabay.com/photo/2017/04/05/22/29/mushroom-2206588_640.jpg",
  },
  {
    id: 4,
    title: "Porçini",
    date: "(Nisan 15-Mayıs 15)",
    desc: "Gastronomi dünyasının en seçkin mantarı olarak bilinen Trüf mantarı, kültür mantarı olarak yetiştirilemeyen ve doğada çok nadir olarak bulunan doğal mantar çeşitleri arasındadır.Yanmış ormanlarda, toprağın altında yetişen mantar çeşidi, ağır bir aromaya sahip olmasına rağmen oldukça lezzetlidir.Kilogram fiyatı 5000 dolar gibi inanılmaz rakamlara yükselebilen mantar, yaz ve kış olmak üzere iki türdedir. ",
    image:
      "https://cdn.pixabay.com/photo/2017/09/11/23/10/goat-lip-2740791_640.jpg",
  },
  {
    id: 5,
    title: "Enoki",
    date: "(Aralık 5-25)",
    desc: "Çiğ olarak yenilebilir olması nedeniyle diğer mantar çeşitlerinden ayrılan Enoki mantarı, özellikle Doğu Asya ülkelerinde sıklıkla kullanılıyor.",
    image:
      "https://cdn.pixabay.com/photo/2015/11/12/17/07/tree-stump-1040639_1280.jpg",
  },
  {
    id: 6,
    title: "Omphalotus Olearius",
    date: "(Mayıs 10-30 )",
    desc: "Ağulu mantar olarak da bilinen mantar çeşidinin yumurta sarısı renge sahiptir.Yenilebilir mantarlarla karıştırılabilen mantar, zeytin ağaçları üzerinde yaygın olarak bulunur.",
    image:
      "https://cdn.pixabay.com/photo/2019/10/07/18/06/mushrooms-4533193_640.jpg",
  },
  {
    id: 7,
    title: "Kültür",
    date: "(Mayıs 15-Haziran30)",
    desc: "Botanikçiler tarafından kültür halinde üretilen mantar türü, tüm dünyada en çok tüketilen mantar çeşididir.Kültür mantarıyla enfes yemekler hazırlanabilir. Omlet, pizza, salata, meze ve etli soteler için kültür mantarını güvenle kullanabilirsiniz.",
    image:
      "https://cdn.pixabay.com/photo/2021/06/08/11/27/mushrooms-6320451_640.jpg",
  },
  {
    id: 8,
    title: "Chanterelle",
    date: "(Ocak 1-30)",
    desc: "Biberimsi, meyvemsi bir lezzete sahip olan chanterelle mantarı; sarı ve turuncu renkli farklı bir mantar türüdür. Yüzey genelde düz bazen pürüzlü, geniş oluklara ayrılmış, kırmızımsı-soluk kahverengi, bazen sarımsı veya gül rengindedir. Ekzoperidyum 1-2 mm kalınlıkta olup kolayca soyulur.",
    image:
      "https://cdn.pixabay.com/photo/2014/09/25/19/30/comatus-460855_640.jpg",
  },
  {
    id: 9,
    title: "Reishi",
    date: "(Ekim 1 Kasım 30)",
    desc: "Alkalaoitler, polisakkaridler, mineraller, vitaminler ve steroller içeren Reishi mantarı kan oksijenlenmesini artırır.Kolesterolü ve tansiyonu düşürür. Karaciğer hastalıklarının tedavisinde önemli rol oynar.Bağışıklık sistemini destekler.",
    image:
      "https://cdn.pixabay.com/photo/2020/04/02/11/20/fungus-4994622_640.jpg",
  },
  {
    id: 10,
    title: "Kanlıca",
    date: "(Ocak 15-Şubat 30)",
    desc: "Lactarius salmonicolor, Lactarius deliciosus ve Lactarius deterrimus olmak üzere üç farklı alt türe ayrılan kanlıca mantarı, özellikle Batı Karadeniz’de yaygın olarak yetişen bir mantar çeşidi. Çam mantarı ya da çıntar olarak da adlandırılan bu türler, genellikle yağda kızartılarak ya da ızgarada pişirilerek tüketiliyor. Dillere destan lezzeti açısından değerli mantar çeşitleri arasında yer alan Kanlıca mantarıyla birbirinden nefis tabaklara imza atabilirsin şefim. Örneğin, mantarlı ve parmesan peynirli risotto reçetesinde kültür mantarının yanı sıra Kanlıca mantarı da kullanabilirsin. ",
    image:
      "https://cdn.pixabay.com/photo/2014/09/16/22/12/mushroom-448866_640.jpg",
  },
  {
    id: 11,
    title: "Tirmit",
    date: "(Mayıs 1-30)",
    desc: "Lactarius volemus olarak adlandırılan tirmit mantarının yaklaşık 5-15 santimetre çapında bir şapkası var. Şapka gençlik döneminde yarım ay formundayken olgunlaşma sürecinde dalgalı bir şekle bürünüyor. Sütlü mantar çeşitleri arasında yer alan tirmit mantarının sütü bulaştığı ciltten kolay kolay çıkmadığı için bu mantar türünün toplanması biraz zahmetli. Ancak olgunlaşınca toplanabiliyor ve genellikle kavurması yapılıyor. Fazla olgunlaşan tirmit mantarını reçetelerde kullanmadan önce haşlamakta yarar var. Aksi takdirde mantarın lezzeti acı olabiliyor. ",
    image:
      "https://cdn.pixabay.com/photo/2019/10/07/18/06/mushrooms-4533193_640.jpg",
  },
  {
    id: 12,
    title: " İmparator",
    date: "(Haziran 1-15)",
    desc: "Sezar mantarı olarak da anılan imparator mantarının Latince karşılığı Amanita caesarea. Eski Roma zamanından beri insanlar tarafından tüketilen imparator mantarı genellikle yaz aylarının sonlarında yetişiyor. Meşe, ıhlamur ve kestane ormanlarında sıklıkla rastlanılan bu tür, oldukça keskin bir aromaya sahip. Ayrıca, imparator mantarının bulunduğu familyada zehirli mantar türleri de yer aldığı için onu toplamak isteyenlerin son derece dikkatli davranması gerekiyor.  ",
    image:
      "https://cdn.pixabay.com/photo/2017/05/02/22/43/mushrooms-2279558_640.jpg",
  },
];
